import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import history from '@utils/history';
import { findByUnion, getNewUnionConfig, findUnionBuoy } from '@action/getUnion';
import { BFD_checkApp, loadFUNJS } from '@utils/bfdApp';
import { unionFlag, checkUnifyShop } from '@utils';
import { checkXcx } from '@utils/checkXcx';
import eHome from '@utils/eHome';
import CityCover from '@df-mobile/city-cover';
import store from '../store';
import routes from '../router';
import { setUnionTitle } from '@df-mobile/utils';

window.isShowSearch = true;
window.showHomePage = false;
window.homePageUrl = "";

class App extends Component {
  async componentDidMount() {
    setUnionTitle();
    this.findInfoByUnion();
    try {
      const isBFDApp = BFD_checkApp();
      console.log("componentDidMount-isBFDApp", isBFDApp);
      if (isBFDApp) {
        loadFUNJS();
        window.df_back = function () {
          let b = false;
          if (document.referrer) {
            window.history.back();
            b = true;
          }
          return b;
        };
      }
    } catch (e) {
      console.log("初始化loadFUNJS失败", e);
    }
  }

  /**
   * TODO: 浙商e家弹窗
   */
  // eslint-disable-next-line react/sort-comp
  findUnionBuoy = async (id) => {
    console.log("props", id);
    const union = unionFlag();
    const isXcx = checkXcx();
    if (!union) return;
    if (union === "ejyshop") {
      const res = await findUnionBuoy({
        unionId: id || 0,
      });
      const { unionBuoyUrl, disPlay } = res?.body || {};
      // console.log('res', res);
      /**
       * 显示浮窗的页面：首页、分类、商品详情页、到店、购物车、品牌详情页、商家详情页、门店列表页、订单列表页、订单详情页
       */
      if (isXcx && disPlay) {
        // console.log(eHome.isHas(), 'eHome.isEmpty', eHome.isEmpty);
        eHome.init({
          url: unionBuoyUrl || "",
          href: "https://m.ejyshop.com/",
        });
        if (eHome.isHas() && eHome.isEmpty) {
          // console.log('empty');
          eHome.reset({
            url: unionBuoyUrl || "",
            href: "https://m.ejyshop.com/",
          });
          const path = window.location.pathname;
          if (
            path.indexOf("show/order") > -1 ||
            path.indexOf("show/people/info") > -1 ||
            path.indexOf("pay/result") > -1 ||
            path.indexOf("select/city") > -1 ||
            path.indexOf("order/ticketCode") > -1 ||
            path.indexOf("logistics") > -1 ||
            path.indexOf("order/addPeople") > -1 ||
            path.indexOf("order/expressAdress") > -1 ||
            path.indexOf("order/addAdress") > -1 ||
            path.indexOf("ticket/Adress") > -1
          ) {
            // console.log('...*****');
            eHome.hide();
          }
        }
      }
    }
  };

  /**
   * 是否展示搜索框
   */
  findInfoByUnion = async () => {
    if (!unionFlag() && !checkUnifyShop()) {
      document.title = '东方福利网-演出';
      return;
    }
    try {
      const unionCode = unionFlag() || sessionStorage.getItem("dffl_union");
      const newConfig = await getNewUnionConfig({
        unionFlag: unionCode ? 1 : 0,
        union: unionCode,
      });
      window.showHomePage = !!(
        newConfig &&
        newConfig.code === 0 &&
        newConfig.data &&
        newConfig.data.showHomePage
      );
      const res = await findByUnion({
        Business: false,
      });
      window.isShowSearch = !!(
        res &&
        res.code === 0 &&
        res.body &&
        res.body.mallUnionConfigDto &&
        res.body.mallUnionConfigDto.isShowSearch
      );
      window.homePageUrl =
        res && res.code === 0 && res.body && res.body.homePageUrl;
      const unionName =
        res &&
        res.body &&
        res.body.mallUnionConfigDto &&
        res.body.mallUnionConfigDto.unionName;
      const unionId =
        res &&
        res.body &&
        res.body.mallUnionConfigDto &&
        res.body.mallUnionConfigDto.unionId;
      localStorage.setItem("unionName", unionName);
      if (localStorage.getItem("unionName")) {
        // document.title = localStorage.getItem("unionName");
      } else {
        // document.title = "东方福利网-演出";
      }
      await this.findUnionBuoy(unionId);
    } catch (err) {
      console.log(err);
      // if (!document.title || document.title === "undefined") {
      //   if (localStorage.getItem("unionName") && sessionStorage.dffl_union) {
      //     document.title = localStorage.getItem("unionName");
      //   } else {
      //     document.title = "东方福利网-演出";
      //   }
      // }
    }
    // try {
    //   const unionCode = unionFlag() || sessionStorage.getItem('dffl_union');
    //   const newConfig = await getNewUnionConfig({
    //     unionFlag: unionCode ? 1 : 0,
    //     union: unionCode,
    //   });
    //   window.showHomePage = !!(newConfig && newConfig.code === 0 && newConfig.data && newConfig.data.showHomePage);
    // } catch (error) {
    //   console.log(error);
    // }
  };

  componentWillUnmount() {
    if (eHome) {
      eHome.clear();
    }
  }

  render() {
    return (
      <Provider store={store}>
        <CityCover type="city" />
        <ConnectedRouter history={history}>{routes(store)}</ConnectedRouter>
      </Provider>
    );
  }
}
export default App;
